import { Niubiz3dsSelector } from './Niubiz3dsSelector';

export default Niubiz3dsSelector;
